import { motion } from 'framer-motion'
import { CheckCircle } from 'lucide-react'

export default function FormSuccess() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-6 text-center"
    >
      <div className="flex flex-col items-center justify-center space-y-4">
        <div className="rounded-full bg-green-100 dark:bg-green-800/30 p-3">
          <CheckCircle className="h-8 w-8 text-green-600 dark:text-green-400" />
        </div>
        <h3 className="text-xl font-semibold text-green-800 dark:text-green-400">Message Sent!</h3>
        <p className="text-green-700 dark:text-green-300 max-w-md">
          Thank you for reaching out. We've received your message and will get back to you as soon as possible.
        </p>
        <motion.div
          initial={{ width: '100%' }}
          animate={{ width: '0%' }}
          transition={{ duration: 5, ease: 'linear' }}
          className="h-1 bg-green-500/50 dark:bg-green-400/50 rounded-full mt-4 w-full"
        />
      </div>
    </motion.div>
  )
}